// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const HomeIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M22.1 9.17 14.2 2.9c-1.3-1.02-3.1-1.02-4.4 0L1.9 9.17c-.46.36-.53 1.02-.17 1.47.36.46 1.02.53 1.47.17l.13-.1v7.15c0 2.2 1.8 4 4 4h9.33c2.21 0 4-1.8 4-4V10.7l.14.1q.3.23.65.23c.31 0 .62-.14.82-.4.36-.45.29-1.11-.17-1.47"
        opacity=".5"
      />
      <path d="M9.8 2.91c1.29-1.02 3.11-1.02 4.4 0l7.9 6.26c.46.36.53 1.02.17 1.47-.36.46-1.02.53-1.47.17l-7.9-6.25c-.53-.42-1.27-.42-1.8 0L3.2 10.8c-.45.36-1.11.29-1.47-.17s-.29-1.11.17-1.47z" />
    </g>
  </SvgIcon>
);

export default HomeIcon;
